"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguageModalBridge = void 0;
const react_1 = require("react");
// Bridges an app-wide custom event to open the language modal owned by ActionPanel
const useLanguageModalBridge = (openModal) => {
    (0, react_1.useEffect)(() => {
        const handler = (e) => {
            const custom = e;
            if (custom?.detail?.projectId) {
                openModal(custom.detail.projectId, custom.detail.languages || []);
            }
        };
        window.addEventListener('open-language-modal', handler);
        return () => window.removeEventListener('open-language-modal', handler);
    }, [openModal]);
};
exports.useLanguageModalBridge = useLanguageModalBridge;
